import { FC } from 'react'
import { IonList } from '@ionic/react'

export interface IListProps {
  lines?: 'none'
  className?: string
  children: React.ReactNode
}

export const List: FC<IListProps> = ({
  children,
  lines = 'none',
  className,
}) => {
  return (
    <IonList className={className} lines={lines}>
      {children}
    </IonList>
  )
}
